import { RolComunidad } from '../../types/comunidad';

/**
 * Cómo se llama y cómo se ve cada rol dentro de la comunidad.
 *
 * POR QUÉ UNA INSIGNIA Y NO SOLO EL NOMBRE
 * ---------------------------------------
 * La comunidad es privada por consultorio, pero dentro de ella_conviven el
 * paciente que pregunta, su familiar respondiendo y el profesional que
 * acompaña: sin distinguir roles, un consejo de un pariente se lee igual
 * que una indicación clínica. La insignia dice quien habla.
 *
 * `ESTUDIANTE` es el nombre que usa la base de datos para los pacientes;
 * para quien lo ve, "Paciente" es lo que significa.
 *
 * REGLA: las clases van ESCRITAS, no construidas con `bg-v-${slot}-100`.
 * Tailwind purga por contenido: una clase que solo existe en runtime no se
 * emite y el cuadro sale sin fondo. Los pares container/tinta son los
 * mismos que ya usa el resto de la app (`NotificacionesPage`), así que
 * pasan el chequeo de contraste.
 */
const INSIGNIAS: Record<RolComunidad, { etiqueta: string; clases: string }> = {
  ESTUDIANTE: { etiqueta: 'Paciente', clases: 'bg-v-azul-100 text-v-azul-700' },
  PADRE: { etiqueta: 'Familia', clases: 'bg-v-ambar-100 text-v-ambar-700' },
  PSICOLOGO: { etiqueta: 'Profesional', clases: 'bg-v-lima-100 text-v-lima-700' },
  ADMIN: { etiqueta: 'Administración', clases: 'bg-v-violeta-100 text-v-violeta-700' },
};

/** Sin rol conocido: se dice "Participante", no se adivina uno. */
const SIN_ROL = { etiqueta: 'Participante', clases: 'bg-v-background text-v-on-surface-variant' };

export function insigniaDe(rol?: RolComunidad | null) {
  if (!rol) return SIN_ROL;
  return INSIGNIAS[rol] ?? SIN_ROL;
}

export default function InsigniaRol({ rol }: { rol?: RolComunidad | null }) {
  const { etiqueta, clases } = insigniaDe(rol);
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${clases}`}
    >
      {etiqueta}
    </span>
  );
}
